<template>
    <div class="root">
        <button :class="{ active }" @click="active = !active">
            {{ label }}

            <div v-if="activeFilters.value.length">
                <span>{{ activeFilters.value.length }}</span>
            </div>
            <img v-else src="/dist/images/arrow-down-orange.svg" :alt="label">
        </button>
        <div v-if="active" v-on-clickaway="away" class="dropdown">
            <p>Filters</p>

            <label v-for="opt in options" :key="opt">
                <input type="checkbox" :checked="isActive(opt)" @change="refine(opt)">
                {{ opt }}
            </label>
        </div>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import refinement from '../../searchy/refinement';

export default {
    mixins: [ clickaway ],

    props: {
        label: {
            type: String,
            required: true
        },

        attribute: {
            type: String,
            required: true
        },

        options: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            active: false,
            activeFilters: null,
            refine: null
        };
    },

    created() {
        const { refine, active } = refinement(this.attribute);
        this.refine = refine;
        this.activeFilters = active;
    },

    methods: {
        isActive(option) {
            return this.activeFilters.value.includes(option);
        },

        away() {
            this.active = false;
        }
    }
};
</script>

<style lang="scss" scoped>
    .root {
        position: relative;
        font-weight: 500;
        font-size: 14px;
        color: #000;
    }

    button {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: space-between;
        padding: 0.75em 1.5em;
        border: 1px solid #DDDDDD;
        border-radius: 999px;

        &.active {
            color: #EF6E0B;
            border-color: #EF6E0B;
            background-color: rgba(#EF6E0B, 0.1);
        }

        &:focus {
            outline: none;
        }

        img {
            width: 10px;
        }

        div {
            width: 21px;
            height: 21px;
            text-align: center;
            background-color: #EF6E0B;
            color: #FFF;
            border-radius: 100%;
            font-size: 11px;
        }

        span {
            display: block;
            transform: translateY(1px);
        }
    }

    .dropdown {
        position: absolute;
        left: 0;
        right: 0;
        z-index: 10;
        margin-top: 1em;
        padding: 1.5em 2em;
        border: 1px solid #DDDDDD;
        background-color: #FFF;

        p {
            margin-bottom: 1.5em;
        }
    }

    label {
        display: flex;
        align-items: center;
        margin-bottom: 1em;
    }

    input {
        appearance: none;
        border: 2px solid #EF6E0B;
        width: 20px;
        height: 20px;
        margin: 0 1em 0 0;

        &:checked {
            background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='black' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e");
        }

        &:focus {
            outline: none;
        }
    }
</style>